@if (isUnified) {
  <!-- Unified Code: advertisements as a static image-card grid; every tile is a real, focusable link. -->
  <section *ngIf="carouselResize.data.length" class="uc-home-section" [dir]="isRtl ? 'rtl' : 'ltr'">
    <div class="container">
      <div class="uc-home-section__header">
        <h2 class="uc-home-section__title uc-display-sm" translate="home.advertisements"></h2>
      </div>
      <ul class="uc-card-grid uc-card-grid--3">
        <li *ngFor="let item of carouselResize.data">
          <a *ngIf="item.url; else adImage" class="uc-card uc-ad-card" [href]="item.url" target="_blank" rel="noopener noreferrer"
            [attr.aria-label]="item.title || ('home.advertisements' | translate)">
            <img loading="lazy" [src]="resources + item.image" alt="">
          </a>
          <ng-template #adImage>
            <div class="uc-card uc-ad-card"><img loading="lazy" [src]="resources + item.image" [alt]="item.title || ''"></div>
          </ng-template>
        </li>
      </ul>
    </div>
  </section>
} @else {
<section *ngIf="carouselResize.data.length" class="py-5">
  <div [dir]="isRtl ? 'rtl' : 'ltr'" class="container">
    <h2 class="home-titles" translate="home.advertisements"></h2>
  </div>
  @if(carouselResize.data)
  {
    @if (carouselResize.data[0].carouselType == advertisingType.ArrowCarousel) {
      <div class="ads-slider mx-auto d-flex align-items-center justify-content-center">
        <button (click)="appCustomCarousel.nextSlide()" class="btn shadow-none border-0 rounded-circle d-flex align-items-center justify-content-center">
          <i class="fa-solid fa-arrow-right"></i>
        </button>
        <app-custom-carousel #appCustomCarousel [content]="trainingCentersContent" [carouselResize]="carouselResize" (shareIndex)="carouselResize.currentIndex = $event" [showControls]="true" [distanceCenterControlsIndicators]="true"></app-custom-carousel>
        <button (click)="appCustomCarousel.previousSlide()" class="btn shadow-none border-0 rounded-circle d-flex align-items-center justify-content-center">
          <i class="fa-solid fa-arrow-left"></i>
        </button>
      </div>
      <ng-template #trainingCentersContent>
        <div class="carousel-container mx-auto position-relative overflow-hidden">
          <ng-container *ngFor="let slide of carouselResize.items; track i; let i = index">
            <div class="carousel-slide px-1 w-100 h-100 position-absolute" [ngStyle]="{left: 'calc('+ i +'*100%)', transform: 'translateX(-'+ carouselResize.currentIndex +'00%)'}">
              <div class="row row-cols-1 h-100 justify-content-center">
                <div class="col h-100" *ngFor="let item of slide; let i = index">
                  <img [alt]="item.title || ''" loading="lazy" [src]="resources + item.image"/>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-template>
    } @else {
      <div class="container">
        <div class="ads w-100 mx-auto d-flex align-items-center">
          <div class="ads-card" *ngFor="let item of carouselResize.data; index as i; first as first; last as last" [ngClass]="{'flex-grow-1': active === i, 'pe-0': first, 'ps-0': last}">
            <a (click)="onClick(i, item.url)" target="_blank">
              <div class="ads-logo" [ngClass]="{'active': active === i}" [ngStyle]="{ 'background-image': 'url('+resources+item.image+')'}"></div>
            </a>
          </div>
        </div>
      </div>
    }
  }

</section>
}
